import { render, staticRenderFns } from "./PreSurveyComment.vue?vue&type=template&id=0b350ae9&scoped=true"
import script from "./PreSurveyComment.vue?vue&type=script&lang=js"
export * from "./PreSurveyComment.vue?vue&type=script&lang=js"
import style0 from "./PreSurveyComment.vue?vue&type=style&index=0&id=0b350ae9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b350ae9",
  null
  
)

export default component.exports